import token, { tokenToVars } from '../token';
import EditableArea from './editable-area';

export { EditableArea };
export default tokenToVars(EditableArea, token);
